/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ASSET_DETAIL } from "../pages/AssetDetail/graphql/asset-detail.query";
import {UPDATE_ASSET_DETAIL } from "../pages/AssetDetail/graphql/edit-asset.mutation";
import { MINT_ASSET } from "../pages/AssetDetail/graphql/mint-asset.mutation";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { DETAIL_DATA} from "./config/product.detail"



const MODULE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class AssetDetailService {
    private static instance: AssetDetailService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): AssetDetailService {
        if (!AssetDetailService.instance) {
            AssetDetailService.instance = new AssetDetailService(props);
        }
        return AssetDetailService.instance;
    }

    // async getCreatedAssetDetail(assetId: string, assetGroup: string) {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     try {
    //         if (client) {
    //             const res = await client.query({
    //                 query: GET_ASSET_DETAIL,
    //                 variables: {
    //                     tokenId: "1",
    //                     storeId: "61739cbd2fbe0a187c984fb6",
    //                 },
    //                 fetchPolicy:'network-only'
    //             });
    //             log.success(MODULE_NAME, "getCreatedAssetDetail: ", res);
    //             if (res?.data?.getAssetDetails?.tabsItems) {
    //                 try {
    //                     // Parse a JSON
    //                     res.data.getAssetDetails.tabsItems = JSON.parse(res?.data?.getAssetDetails?.tabsItems);
    //                 } catch (e) {
    //                     // You can read e for more info
    //                 }
    //             }
    //             return res?.data?.getAssetDetails;
    //         }
    //     } catch (err) {
    //         return err;
    //     }
    // }
    async getCreatedAssetDetail(assetId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId:assetId,
                        // storeId:"61739cbd2fbe0a187c984fb6"
                    },
                });
                if(res){
                    let _data = res?.data?.getAsset
                    let _found ={
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        serialNo: _data?.serialNo,
                        tag: 'GOLD',
                        category: 'gold',
                        price: _data?.price,
                        meta: _data?.attrs?.map((item:any)=>{
                            return({
                                key:item?.name,
                                value: item?.val,
                                disp_type:item?.disp_type
                            })
                        }),
                        buttons: [
                            // {
                            //     key: "buyNowFiat",
                            //     title: "Buy in USD"
                            // },
                            // {
                            //     key: "buyNowCrypto",
                            //     title: "Buy in ETH"
                            // }
                            {
                                key:"mint",
                                title:"Mint"
                            },
                            {
                                key:"edit",
                                title:"Edit"
                            }
                        ],
                        images: _data?.media?.map((item:any)=>{
                            return({
                                // ...item,
                                original:item?.src,
                                thumbnail:item?.src,
                                thumbnailHeight: "70",
                                thumbnailClass:"image-thumb"
                            })
                        }),
                        // timeline: _data?.timeline?.map((item:any)=>{
                        //     return({
                        //         title: item?.event,
                        //         description:[
                        //             // {
                        //             //     displayType: "date",
                        //             //     key: "Listed At",
                        //             //     value: item?.date?.toISOString()
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "From",
                        //             //     value: item?.from?.value,
                        //             //     link: item?.from?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "To",
                        //             //     value: item?.to?.value,
                        //             //     link: item?.to?.link
                        //             // },
                        //             // {
                        //             //     displayType: "link",
                        //             //     key: "Proof of List",
                        //             //     value: item?.proof?.value,
                        //             //     link: item?.proof?.link
                        //             // }
                        //         ]
                        //     })
                        // }),
                    }
                if(_found){
                    return _found;
                }
                
                }
                // log.success(SERVICE_NAME, "get asset detail result: ", res);
                // // return res?.data?.getAssets;
                // return res?.data?.getAsset;
            }
        } catch (err) {
            return err;
        }
    }

    // async getCreatedAssetDetail(assetId: string) {
    //     const _found = _.find(DETAIL_DATA, {
    //         idx: assetId,
    //     });
    //     return _found;
    // }

    async editAssetDetail(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service`, formData);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_ASSET_DETAIL,
                    variables: {
                        updateAssetAssetId: formData?.assetId,
                        updateAssetData: {...formData.data}
                    },
                    fetchPolicy:"no-cache"
                });
                log.success(MODULE_NAME, "update asset: ", res);
                return res?.data;
            }
        } catch (err) {
            return err;
        }
    }

    async mintAsset(assetId: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `assetId in service`, assetId);
        
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: MINT_ASSET,
                    variables: {
                        tokenId:assetId?.assetId
                    },
                    fetchPolicy:"no-cache"
                });
                log.success(MODULE_NAME, "mintAssetRes: ", res);
                return res?.data;
            }
        } catch (err) {
            return err;
        }
    }
}
